/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Coil_Hydraulic_HeatingInputs */



/**
* | output |
* | --- |
* | "Heating coil" |
*
* @param {Air_Handler_Unit_Coil_Hydraulic_HeatingInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_coil_hydraulic_heating = /** @type {((inputs?: Air_Handler_Unit_Coil_Hydraulic_HeatingInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Coil_Hydraulic_HeatingInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Heating coil")
	return /** @type {LocalizedString} */ ("Batterie Chaude")
});